export function isFunction(obj: unknown): obj is (...args: any) => unknown {
  return typeof obj === 'function';
}
